// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"clearfix-1IDNcLp-","box_06_title":"box_06_title-1d3I-5-a","more":"more-25FdJo0f","title_word":"title_word-l9_1PqJk"};